var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCovidTrackerColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da291c;}.cls-2{fill:#545859;}.cls-3{fill:#d9d9d6;}.cls-4{fill:#eaaa00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    className: "cls-3",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Covid_Tracker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.09,27.82c0-4.14,3.33-7.47,7.47-7.47h24.89c4.14,0,7.47,3.33,7.47,7.47s-3.33,7.47-7.47,7.47h-4.98v10.45c9.55,1.31,18.29,5.07,25.61,10.61l7.4-7.37-3.52-3.55c-2.92-2.92-2.92-7.65,0-10.55,2.92-2.89,7.65-2.92,10.55,0l17.61,17.61c2.92,2.92,2.92,7.65,0,10.55-2.92,2.89-7.65,2.92-10.55,0l-3.55-3.52-7.4,7.4c5.57,7.31,9.3,16.09,10.61,25.61h10.48v-4.98c0-4.14,3.33-7.47,7.47-7.47s7.47,3.33,7.47,7.47v24.89c0,4.14-3.33,7.47-7.47,7.47s-7.47-3.33-7.47-7.47v-4.98h-10.45c-1.31,9.55-5.07,18.29-10.61,25.61l7.37,7.4,3.52-3.52c2.92-2.92,7.65-2.92,10.55,0,2.89,2.92,2.92,7.65,0,10.55l-17.61,17.61c-2.92,2.92-7.65,2.92-10.55,0s-2.92-7.65,0-10.55l3.55-3.55-7.4-7.4c-7.31,5.57-16.09,9.3-25.61,10.61v10.48h4.98c4.14,0,7.47,3.33,7.47,7.47s-3.33,7.47-7.47,7.47h-24.89c-4.14,0-7.47-3.33-7.47-7.47s3.33-7.47,7.47-7.47h4.98v-10.45c-9.55-1.31-18.29-5.07-25.61-10.61l-7.4,7.37,3.52,3.52c2.92,2.92,2.92,7.65,0,10.55-2.92,2.89-7.65,2.92-10.55,0l-17.61-17.58c-2.92-2.92-2.92-7.65,0-10.55s7.65-2.92,10.55,0l3.55,3.52,7.4-7.4c-5.57-7.31-9.33-16.05-10.64-25.61h-10.45v4.98c0,4.14-3.33,7.47-7.47,7.47s-7.47-3.33-7.47-7.47v-24.89c0-4.14,3.33-7.47,7.47-7.47s7.47,3.33,7.47,7.47v4.98h10.45c1.31-9.55,5.07-18.29,10.61-25.61l-7.37-7.4-3.55,3.52c-2.92,2.92-7.65,2.92-10.55,0s-2.92-7.65,0-10.55l17.61-17.61c2.92-2.92,7.65-2.92,10.55,0s2.92,7.65,0,10.55l-3.52,3.55,7.4,7.4c7.31-5.57,16.09-9.3,25.61-10.61v-10.48h-4.98c-4.14,0-7.47-3.33-7.47-7.47Zm14.93,62.23c0-8.25-6.69-14.93-14.93-14.93s-14.93,6.69-14.93,14.93,6.69,14.93,14.93,14.93,14.93-6.69,14.93-14.93Zm19.91,32.36c4.12,0,7.47-3.34,7.47-7.47s-3.34-7.47-7.47-7.47-7.47,3.34-7.47,7.47,3.34,7.47,7.47,7.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80.09,
    cy: 90.04,
    r: 15.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 114.93,
    cy: 114.93,
    r: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.53,
    y: 35.3,
    width: 14.93,
    height: 10.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.53,
    y: 154.44,
    width: 14.93,
    height: 10.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.06,
    y: 94.78,
    width: 14.93,
    height: 10.44,
    transform: "translate(-59.48 140.52) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.07,
    y: 94.78,
    width: 14.93,
    height: 10.44,
    transform: "translate(59.54 259.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.59,
    y: 52.72,
    width: 14.93,
    height: 10.44,
    transform: "translate(-23.97 58.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 134.53,
    y: 136.67,
    width: 14.93,
    height: 10.44,
    transform: "translate(-58.74 141.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 134.48,
    y: 52.72,
    width: 14.93,
    height: 10.44,
    transform: "translate(201.34 199.29) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.53,
    y: 136.67,
    width: 14.93,
    height: 10.44,
    transform: "translate(-1.32 283.23) rotate(-135)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidTrackerColor);
export default __webpack_public_path__ + "static/media/CovidTracker_Color.319d0b59f918b3fd53ba2387c2eda67a.svg";
export { ForwardRef as ReactComponent };